import { Text, View } from "@react-pdf/renderer";
import { Choice, Page } from "../types";
import PdfChoice from "./PdfChoice";
import styles from "./PdfStyles";

interface PdfChoicePagesProps {
  page?: Page;
  choicesGroupedByPage?: Choice[];
}

const PdfChoicePages: React.FC<PdfChoicePagesProps> = ({
  page,
  choicesGroupedByPage,
}) => {
  if (!page) return null;
  if (!choicesGroupedByPage) return null;
  return (
    <View style={{ ...styles.row, ...styles.bordered }}>
      <View style={styles.column}>
        <Text style={styles.heading}>{page.short}</Text>
      </View>
      <View style={styles.doubleColumn}>
        {choicesGroupedByPage.map((choice) => (
          <PdfChoice key={choice.id} page={page} choice={choice} />
        ))}
      </View>
    </View>
  );
};
export default PdfChoicePages;
